import { render, staticRenderFns } from "./SnSerialManageList.vue?vue&type=template&id=331bd462&"
import script from "./SnSerialManageList.vue?vue&type=script&lang=js&"
export * from "./SnSerialManageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports